import script from "./DashboardMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardMessage.vue?vue&type=script&setup=true&lang=js"

import "./DashboardMessage.vue?vue&type=style&index=0&id=f063c238&lang=css"

const __exports__ = script;

export default __exports__